import { getStatusDescriptionFromStatusValue,getCountryNameByCountryCode } from '../../../../../utils/utility';
import { getDateWithSpecificFormat } from '../../../../data-transform';

export default function exportPartnerFinancialsTableFields(config) {
    let result = {};
    let tableData = [];
    let rowCount = 0;

    const { financialList = [] } = config.data;

    financialList.map((financialListItem) => {
        let row = [];
        const rowId = `${financialListItem.orderId}-${rowCount}`;
        config.columns.forEach(column => {

            let columnValue = "";
            let customEventHandler = null;
            const columnDataType = column.data.displayInBodyAs;
            let isDisabled = false;

            let displayAsIs = column.data.displayInBodyAsIs;
            if (column.data.displayInBodyAs === "string") {
                if (column.id === "orderId") {
                    columnValue = financialListItem.orderId || "";
                    displayAsIs = true;
                }
                else if (column.id === "orderType") {
                    columnValue = financialListItem.orderType?(financialListItem.orderType==="1"?"Collection":"Self shipment"):"";
                    displayAsIs = true;
                }
                else if (column.id === "country") {
                    columnValue = getCountryNameByCountryCode(financialListItem.countryCode) || "";
                    displayAsIs = true;
                }
                else if (column.id === "legalEntityName") {
                    columnValue = financialListItem.legalEntity || "";
                    displayAsIs = true;
                }
                else if (column.id === "reportingDate") {                    
                    columnValue = getDateWithSpecificFormat(financialListItem.reportAvailableDate) || "";
                    displayAsIs = true;
                }
                else if (column.id === "hpReportingDate") {                    
                    columnValue = getDateWithSpecificFormat(financialListItem.hpReportingDate) || "";
                    displayAsIs = true;
                }
                else if (column.id === "transactionType") {
                    columnValue = financialListItem.lineType || "";
                    displayAsIs = true;
                }
                else if (column.id === "partnerPaymentStatus") {
                    columnValue = getStatusDescriptionFromStatusValue(financialListItem.paymentStatus) || "";
                    displayAsIs = true;
                }
                else if (column.id === "partnerInvoiceDate") {
                    columnValue = financialListItem.partnerInvoiceDate || "";
                    displayAsIs = true;
                }
                else if (column.id === "partnerAmount") {
                    columnValue = financialListItem.vendorAmount || "";
                    displayAsIs = true;
                }
                else if (column.id === "currency") {
                    columnValue = financialListItem.currencyCode || "";
                    displayAsIs = true;
                }
                else if (column.id === "revitalizeOrder") {
                    columnValue = getStatusDescriptionFromStatusValue(financialListItem.revitalizeOrder) || "";
                }
                else if (column.id === "HPInvoiceNumber") {
                    columnValue = financialListItem.hpInvoiceNo || "";
                    displayAsIs = true;
                }
                else if (column.id === "HPPONumber") {
                    columnValue = financialListItem.hpPONo || "";
                    displayAsIs = true;
                }
                else if (column.id === "partnerInvoiceNumber") {
                    columnValue = financialListItem.partnerInvoiceNo || "";
                    displayAsIs = true;
                }
                else if (column.id === "partnerPONumber") {
                    columnValue = financialListItem.partnerPONo || "";
                    displayAsIs = true;
                }
                else if (column.id === "invoiceStatus") {
                    columnValue = financialListItem.invoiceStatus || "";
                    displayAsIs = true;
                }
                else if (column.id === "partnerPaymentDate") {
                    columnValue = financialListItem.paymentDate || "";
                    displayAsIs = true;
                }
                else if (column.id === "HPPartner") {
                    columnValue = financialListItem.vendorName || "";
                    displayAsIs = true;
                }
                else if (column.id === "customerPaymentType") {
                    columnValue = financialListItem.customerPaymentType || "";
                    displayAsIs = true;
                }
                else if (column.id === "company") {
                    columnValue = financialListItem.company || "";
                    displayAsIs = true;
                    isDisabled= true;
                }
            }

            row.push({
                [column.id]: {
                    id: column.id + "|" + rowId,
                    type: column.data.displayInBodyAs,
                    value: columnValue,
                    width: column.width,
                    disabled: isDisabled,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    clickHandler: customEventHandler
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });

        rowCount++;
    });


    result['columns'] = config.columns;
    result['data'] = tableData;

    return result;
}